export default {
  page: {
    register: "Register",
    login: "Login",
    increase: "Complete Profile",
    phoneRegister: "Phone Register",
    bindRegister: "Bind Register",
    bindLogin: "Bind Info",
    supplement: "Supplement",
    loginSuccess: "Login Success",
    retrievePassword: "Reset Password",
    setPassword: "Set Password",
    loginTip: "Login Tip",
  },
  common: {
    register: "Register",
    logout: "Logout",
    hasAccount: "Already have an account? Login",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    submit: "Submit",
    back: "Back",
    nextStep: "Next",
    loading: "Loading...",
    loginNow: "Login Now",
    registerNow: "Register Now",
    forgetPassword: "Forgot Password",
    rememberPassword: "Remember Password",
    getCaptcha: "Get Code",
    captcha: "Captcha",
    defaultLogin: "Default Login",
    otherLogin: "Other Login",
    captchaLogin: "Captcha Login",
    passwordLogin: "Password Login",
    secondsLeft: "s",
    noAccount: "No account?",
    savePassword: "Save Password",
    password: "Password",
    pleaseInputPassword: "Please enter password",
    phoneAreaCodeTip: "Please enter area code, e.g. 86",
    bind: "Bind",
    noRegisterBind: "Not registered? Complete info to bind",
    hasAccountBind: "Already have an account? Login to bind",
    bindRegisterTip:
      "Since this is your first time logging in with WeChat/QQ, please complete your account information and create a password for future login.",
    bindLoginTitle:
      "Please login with your registered account to complete identity binding",
    bindRegisterTitle:
      "Please complete your account information to finish identity binding",
  },
  field: {
    required: "Please fill in {name}",
    pattern: "Please enter a valid {name}",
    unique: "{name} already registered",
    repeat: "{name} already exists",
    number: "Please enter a number",
    phone: "Phone Number",
    correctPhone: "Please enter a valid phone number",
    email: "Email",
    phoneOrEmail: "Phone/Email",
    maxLength: "Maximum {length} characters",
    please_select: "Please select",
    please_input: "Please enter {name}",
    please_answer: "Please answer",
    please_input_captcha: "Please enter the captcha",
    please_upload: "Please upload",
  },
  login: {
    already_registered:
      "The {name} you entered is already registered, please login",
    passwordLengthError: "Please enter 6-20 characters",
    userUnderReview:
      "Current user is under review, binding is temporarily unavailable.",
    userDisabled:
      "Current user is disabled, binding is temporarily unavailable.",
    pleaseAuthorizeFirst: "Please authorize first before binding!",
    please_login: "Please login first",
    login_success: "Login successful",
    register_success: "Registration successful",
    logout_success: "Logout successful",
  },
  error: {
    100054: "The email already exists, please enter another email",
  },
  lang: {
    zh_CN: "中文",
    en_US: "English",
    zh_TW: "繁體中文",
  },
};
